export enum PermissionErrorHandlingResult {
  HANDLED_WITH_ERROR = 'HANDLED_WITH_ERROR',
  HANDLED_WITHOUT_ERROR = 'HANDLED_WITHOUT_ERROR',
  DEFAULT = 'DEFAULT',
}
